<div class="text-center">
  <ng-container [ngSwitch]="state">
    <ng-container *ngSwitchCase="'loading'">
      <div class="d-flex align-items-center flex-dir-row nowrap">
        <div>
          <div class="fs-20">Loading {{loadingItemText}}...</div>
          <div class="mt-2 mb-15 fs-12 c-grey-1">{{loadingSubText || 'Stay tuned to see your data.'}}</div>
        </div>
        <app-spinner class="p-relative not-5 ml-10" [diameter]="36" [strokeWidth]="5"></app-spinner>
      </div>
    </ng-container>
    
    <ng-container *ngSwitchCase="'refreshing'">
      <div class="d-flex align-items-center flex-dir-row nowrap">
        <div>
          <div class="fs-20">Refreshing data...</div>
          <div class="mt-2 mb-15 fs-12 c-grey-1">{{refreshingSubText || 'Stay tuned to see your data.'}}</div>
        </div>
        <app-spinner class="p-relative not-5 ml-10" [diameter]="36" [strokeWidth]="5"></app-spinner>
      </div>
    </ng-container>
    
    <ng-container *ngSwitchCase="'unavailable'">
      <div class="mb-20 fs-20">This {{itemText}} is unavailable.</div>
    </ng-container>

    <ng-container *ngSwitchCase="'deleted'">
      <div class="mb-20 fs-20">This {{itemText}} is deleted.</div>
    </ng-container>

    <ng-container *ngSwitchCase="'error'">
      <div class="mb-20 fs-20">An error occurred when loading this {{itemText}}.</div>
    </ng-container>
  </ng-container>
</div>
